import React from 'react';
import { useMediaQuery } from '@mui/material';
import { Colors } from 'library';
import { Alert, Checkbox, Icon, IconButton, ResponsiveRow, Row, DatePicker, Text } from 'library/ui';
import { addDays, addWeeks, startOfWeek, subDays, subWeeks } from 'date-fns';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { BadgeOutlined } from '@mui/icons-material';
import theme from 'theme';
import { formatDateFromDateObject } from 'shared/Dates';

export default function CalendarFilters({
    currentDay,
    setCurrentDay,
    showWeekend,
    setShowWeekend,
}: {
    currentDay: Date;
    setCurrentDay: (d: Date) => void;
    showWeekend: boolean;
    setShowWeekend: (show: boolean) => void;
}) {
    const mdDown = useMediaQuery(theme.breakpoints.down('lg'));

    function next() {
        const newDate = addWeeks(currentDay, 1);
        setCurrentDay(mdDown ? addDays(currentDay, 1) : startOfWeek(newDate));
    }

    function last() {
        const newDate = subWeeks(currentDay, 1);
        setCurrentDay(mdDown ? subDays(currentDay, 1) : startOfWeek(newDate));
    }

    return (
        <ResponsiveRow gap="md" collapseAt="lg" justify="between" align="center" alignWhenStacked="center">
            <Alert variant="warning">
                <Row gap="sm" align="center">
                    <Icon icon={BadgeOutlined} size="sm" iconColor={Colors.white} bgColor={Colors.warning} />
                    <Text size="sm" lineHeight="relaxed">
                        <Text size="sm" weight="semibold">
                            Before each sub&rsquo;s first shift:
                        </Text>{' '}
                        Print all documents in their profile and verify their identity against the photo ID on file when
                        they arrive.
                    </Text>
                </Row>
            </Alert>
            <Row gap="sm" justify={mdDown ? 'center' : 'end'}>
                {!mdDown && <Checkbox label="Show 7-day week" checked={showWeekend} onChange={setShowWeekend} />}
                <IconButton icon={ArrowBackIosIcon} onClick={last} />
                <DatePicker
                    value={currentDay ? formatDateFromDateObject(currentDay) : ''}
                    onChange={(value) => {
                        if (value) setCurrentDay(new Date(`${value}T00:00:00`));
                    }}
                />
                <IconButton icon={ArrowForwardIosIcon} onClick={next} />
            </Row>
        </ResponsiveRow>
    );
}
